export default __webpack_public_path__ + "static/media/Paolo Ciampi premiato.42a66a0d.jpg";